import EsusView from 'components/esus/EsusView'

export default function VisitaDomiciliarTerritorialView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoVisitaDomiciliar' />
}
